import { BadgeCheck, ShieldCheck, Umbrella, MapPin, Building2, Sparkles, Award, Medal, Trophy, Star, Crown, Zap, ThumbsUp } from "lucide-react";

// Mirror of backend achievements.BADGES (earned only from real activity)
export const BADGES = [
  { key: "identity_verified", label: "Identity Verified", desc: "Photo ID checked by our team", group: "verification", Icon: BadgeCheck },
  { key: "dbs_checked", label: "DBS Verified", desc: "DBS certificate verified by My Clean Connect™ within the last 12 months", group: "verification", Icon: ShieldCheck },
  { key: "insured", label: "Insured", desc: "Public liability insurance in place", group: "verification", Icon: Umbrella },
  { key: "address_verified", label: "Address Verified", desc: "Home address confirmed", group: "verification", Icon: MapPin },
  { key: "company_verified", label: "Cleaning Company Verified", desc: "Registered company details checked", group: "verification", Icon: Building2 },

  { key: "first_clean", label: "First Clean Completed", desc: "Completed their first verified booking", group: "milestone", Icon: Sparkles },
  { key: "cleans_10", label: "10 Cleans Completed", desc: "Completed 10 verified bookings", group: "milestone", Icon: Award },
  { key: "cleans_50", label: "50 Cleans Completed", desc: "Completed 50 verified bookings", group: "milestone", Icon: Medal },
  { key: "cleans_100", label: "100 Cleans Completed", desc: "Completed 100 verified bookings", group: "milestone", Icon: Trophy },

  { key: "highly_rated", label: "Highly Rated", desc: "4.5+ average from 5+ reviews", group: "performance", Icon: Star },
  { key: "top_rated", label: "Top Rated", desc: "4.8+ average from 10+ reviews", group: "performance", Icon: Crown },
  { key: "fast_responder", label: "Fast Responder", desc: "Replies within 30 minutes", group: "performance", Icon: Zap },
  { key: "reliable", label: "Reliable Cleaner", desc: "No cancellations across 20+ jobs", group: "performance", Icon: ThumbsUp },
];

export const BADGE_GROUPS = [
  { key: "verification", label: "Verification" },
  { key: "milestone", label: "Booking Milestones" },
  { key: "performance", label: "Performance" },
];

export const BADGE_MAP = Object.fromEntries(BADGES.map((b) => [b.key, b]));
